.NavBar {
  align-items: center;
  background: white;
  border-bottom: 1px #eeeeee solid;
  display: inline-flex;
  height: 48px;
  justify-content: center;
  width: 100%;
}

.BrandTabs {
  z-index: 1;
  align-items: flex-start;
  display: flex;
  justify-content: flex-start;
  background: transparent;
  border: 0;
  &.activeTab {
    border-bottom: 2px solid var(--brand-button-color);
  }
}

.Tab {
  align-items: center;
  cursor: pointer;
  display: flex;
  gap: 8px;
  justify-content: center;
  padding: 16px 24px;
  width: 166px;
}

.BrandLogo {
  height: 16px;
  position: relative;
  width: 16px;
}

.Label {
  color: #121212;
  font-family: Montserrat, sans-serif;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  word-wrap: break-word;
}

@media screen and (max-width: 450px) {
  .BrandTabs {
    width: 50%;
  }
  .Tab {
    width: 100%;
  }
}
